/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import {
    Card,
    CardBody,
    CardHeader
} from "reactstrap";
import {LineRevenueChart} from "./FlashCharts"

const Revenue = () => {
    const [revenueData,setRevenueData]=useState({
        "actual": [411861, 562242, 574778, 544241, 605465, 514348, 536621, 601969, 563783, 531691, null, null],
        "budget": [500001, 500201, 553201, 523501, 547201, 514248, 546621, 535225, 505025, 531691, null, null],
        "ly": [491861, 401861, 457861, 307861, 376261, 401261, 516621, 496624, 452624, 472624, 492624, 488624],
        "forecast": [550501, 450501, 420706, 410706, 435206, 436106, 448106, 448706, 458206, 428506, null, null],
      })

    return (
        <React.Fragment>
            <Card>
                <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Total Revenue</h4>
                    <div className="flex-shrink-0">
                        <div className="d-flex">
                        </div>
                    </div>
                </CardHeader>

                <CardBody>
                   <LineRevenueChart
                        revenueData={revenueData}
                        dataColors='["--vz-success","--vz-danger", "--vz-warning","--vz-primary"]'
                    />
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default Revenue;
